import React from "react";
import renderIf from "../../utils/renderIf";

const Logo = ({ source }) =>
  renderIf(source)(<img className="app-logo" alt="Copart" src={source} />);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js